import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  debug: false,

  // Error tracking only — performance tracing costs client JS and main-thread work for very
  // little value here.
  //
  // Simply omitting `integrations` does NOT achieve that: browserTracingIntegration is one of
  // @sentry/nextjs's DEFAULT integrations, so it kept initialising. Proof it was still running:
  // the `sentry-tracing-init` performance mark showed up on every page load (Lighthouse reported
  // it at ~436ms in production), and browserMetrics registered its web-vitals observers.
  //
  // So filter it out explicitly. Use the callback form rather than `integrations: []` — an empty
  // array would drop error capture too, which is the one thing we do want.
  integrations: (defaults) => defaults.filter((i) => i.name !== 'BrowserTracing'),

  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Non-Error promise rejection captured',
    /ChunkLoadError/,
  ],

  transportOptions: {
    fetchOptions: { keepalive: true },
  },
});
